import { createReducer, on } from '@ngrx/store';
import { loadRandomShowcasePhotos, loadRandomShowcasePhotosFailure, loadRandomShowcasePhotosSuccess } from '../actions';
import { ShowcaseStoriesState } from '../showcase-stories.state';

function getLayout(num) {
    if (num >= 5) return 5;
    if (num >= 3) return 3;
    return 1;
}

const initialState: ShowcaseStoriesState = {
    photos: [],
    layout: 1,
    loading: false,
    loaded: false,
    error: null
};


export const showcaseReducer = createReducer(initialState,
    on(loadRandomShowcasePhotos, state => ({
        ...state,
        loaded: false,
        loading: true,
        error: null
    })),

    on(loadRandomShowcasePhotosSuccess, (state, action) => {
        const guestPhotos = action.photos.filter(photo => photo.IsGuestPhoto === true);
        const propertyPhotos = action.photos.filter(photo => photo.IsGuestPhoto === false);

        // Guest photos take the header only once there are enough to fill layout 3 - a single guest photo
        // blown up to the layout 1 slot is what the design rules out. Below that fall back to property
        // photos rather than mixing the two, and slice to the layout so state never carries slots the
        // chosen layout cannot show.
        const selected = guestPhotos.length >= 3 ? guestPhotos : propertyPhotos;
        const layout = getLayout(selected.length);

        return {
            ...state,
            layout,
            photos: selected.slice(0, layout),
            loading: false,
            loaded: true,
            error: null
        };
    }),

    on(loadRandomShowcasePhotosFailure, (state, action) => ({
        ...state,
        photos: [],
        loading: false,
        loaded: false,
        error: action?.error
    }))
);
